import React, { Component } from 'react';
import Select from 'react-select';

class AccountSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accountList: [],
            selectedAccount: null
        }
    }

    componentDidMount() {
        const { connectedAcc, onConnectedAccountChange } = this.props;
        if (connectedAcc && connectedAcc.length > 0) {
            let formatedOptions = connectedAcc.map(item => ({ label: item.ConnectedAccounts.accountName, value: item.ConnectedAccounts.id }));
            if (formatedOptions && formatedOptions.length > 0) {
                formatedOptions = [...formatedOptions, { label: 'other', value: null }];
                onConnectedAccountChange(connectedAcc[0].ConnectedAccounts.id);
                this.setState({ accountList: formatedOptions, selectedAccount: formatedOptions[0] });
            }
        }
    }

    onChangeHandler = (e) => {
        this.props.onConnectedAccountChange(e?.value);
        this.setState({ selectedAccount: e });
    }



    render() {
        const { selectedAccount, accountList } = this.state;
        return <div className="col-md-12">
            <div className="form-group position-relative">
                <Select className="selectpicker" options={accountList} classNamePrefix="selectpicker" value={selectedAccount} onChange={(e) => this.onChangeHandler(e)} />
            </div>
        </div>
    }
}


export default AccountSelect
